import { render } from "./RegisterBusinessComponent.vue?vue&type=template&id=08f24598&scoped=true"
import script from "./RegisterBusinessComponent.vue?vue&type=script&lang=js"
export * from "./RegisterBusinessComponent.vue?vue&type=script&lang=js"

import "./RegisterBusinessComponent.vue?vue&type=style&index=0&id=08f24598&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f24598"]])

export default __exports__